import { AlertTriangle, Check, Folder, FolderPlus } from 'lucide-react';
import { DialogBody } from '@/shared/components';
import { cn } from '@/shared/lib/cn';

export interface FolderTarget {
  path: string;
  label: string;
}

interface Props {
  targets: FolderTarget[];
  selected: string | null;
  onSelect: (path: string) => void;
  onCreateSubfolder: () => void;
}

/** Ziel-Ordner-Liste für Move-Dialoge (Einzel + Bulk): auswählbare Ordner + „Neuer Unterordner". */
export function FolderTargetPicker({ targets, selected, onSelect, onCreateSubfolder }: Props) {
  return (
    <DialogBody className="space-y-1">
      {targets.map((t) => (
        <button
          key={t.path}
          type="button"
          onClick={() => onSelect(t.path)}
          className={cn(
            'flex w-full items-center gap-2.5 rounded-md border px-3 py-2.5 text-left text-sm transition-colors',
            selected === t.path
              ? 'border-sealwax bg-sealwax/10 text-sealwax'
              : 'border-line hover:bg-card-alt',
          )}
        >
          <Folder size={15} className="shrink-0 opacity-70" />
          <span className="min-w-0 flex-1 truncate">{t.label}</span>
          {selected === t.path && <Check size={15} className="shrink-0" />}
        </button>
      ))}
      <button
        type="button"
        onClick={onCreateSubfolder}
        className="border-line hover:bg-card-alt text-ink-soft flex w-full items-center gap-2.5 rounded-md border border-dashed px-3 py-2.5 text-left text-sm transition-colors"
      >
        <FolderPlus size={15} className="shrink-0 opacity-70" />
        Neuen Unterordner anlegen…
      </button>
      {targets.length === 0 && (
        <p className="text-ink-soft border-line flex items-start gap-2 rounded-md border px-3 py-2.5 text-xs">
          <AlertTriangle size={14} className="mt-0.5 shrink-0" />
          Kein weiterer Ordner in dieser Kategorie. Legen Sie zuerst einen Unterordner an.
        </p>
      )}
    </DialogBody>
  );
}
